import React from "react";
import {
  Box,
  Tabs,
  Tab,
  Grid,
  FormControlLabel,
  FormGroup,
} from "@mui/material";
import { useState } from "react";
import TabPanel from "../../../components/TabPanel";
import AgGridPaginatedTable from "../../../components/AgGridPaginatedTable";
import Checkbox from "@mui/material/Checkbox";
import { billAvaTaxTable, billGLImpaactTable } from "../../../config/grid-column-defs";
import { getTransactionSalesOrderAvatax } from "../../../api/transaction-type";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import useSnackbar from "../../../hooks/useSnackbar";

export default function BillAvaTax() {
  const [tabIndexAvaTax, setTabIndexAvaTax] = useState(0);
  const snackbar = useSnackbar();
  const { data: user } = useSelector((state) => state.user);
  const params = useParams();
const [rowData, setRowData] = useState([]);

  async function getTransactionAvataxLogData(limit, offset) {
    try {
      const { data } = await getTransactionSalesOrderAvatax(user.token, {
        id: params.docNo,
        limit,
        offset,
      });
      setRowData(data.data)
      return {
        rows: data.data.data,
        total: data.data.total,
        error: false,
      };
    } catch (error) {
      console.log(error);
      snackbar.showError("Error In Loading Data.");
      return { error: true };
    } finally {
      // setLoading(false);
    }
  }

  return (
    <>
      <Box className="viewDetilsBox">
        <Grid container pb={2}>
          <Grid item xs={12} sm={6}>
            <FormGroup>
              <FormControlLabel control={<Checkbox disabled/>} label="ACCRUE USE TAX" />
            </FormGroup>
          </Grid>
          <Grid item xs={12} sm={6}>
            <p className="tFormlabel">ACCRUED TAX AMOUNT</p>
            <p className="tFormName">{rowData.accure_tax_amount}</p>
          </Grid>
          <Grid item xs={12} sm={6}>
            <p className="tFormlabel">TAX CALCULATED BY AVATAX</p>
            <p className="tFormName">{rowData.tax_calculated_by_avatax}</p>
          </Grid>
        </Grid>
        <Box
          sx={{
            maxWidth: { xs: 320, sm: 480, md: "100%" },
            bgcolor: "#fff",
          }}
        >
          <Tabs
            value={tabIndexAvaTax}
            // onChange={handleChange}
            onChange={(e, nv) => {
              setTabIndexAvaTax(nv);
            }}
            variant="scrollable"
            scrollButtons="auto"
            aria-label="scrollable auto tabs example"
            className="tabs-sub-bkg"
          >
            <Tab label="GL IMPACT" />
            <Tab label="Logs" />
          </Tabs>
          <TabPanel value={tabIndexAvaTax} index={0}>
            <AgGridPaginatedTable
              //getTableRows={getTransactionShippingAddressData}
              columns={billGLImpaactTable}
              perPage={5}
              refreshCounter={0}
            />
          </TabPanel>
          <TabPanel value={tabIndexAvaTax} index={1}>
            <AgGridPaginatedTable
              getTableRows={getTransactionAvataxLogData}
              columns={billAvaTaxTable}
              perPage={5}
              refreshCounter={0}
            />
          </TabPanel>
        </Box>
      </Box>
    </>
  );
}
